import * as React from 'react'
import { FormatDateOptions, MessageDescriptor } from 'react-intl'

import { messages } from '@/locales/en_US'

export const DEFAULT_MESSAGE = 'missing label'

export type ValuesType =
  | Record<
      string,
      | string
      | number
      | boolean
      | React.ReactElement<
          any,
          | string
          | ((
              props: any
            ) => React.ReactElement<
              any,
              | string
              | any
              | (new (props: any) => React.Component<any, any, any>)
            > | null)
          | (new (props: any) => React.Component<any, any, any>)
        >
      | null
      | undefined
    >
  | undefined

export function buildI18nFunction(
  t: (message: MessageDescriptor, values?: ValuesType) => React.ReactNode
): (id: keyof typeof messages, values?: ValuesType) => React.ReactNode {
  return (id: keyof typeof messages, values?: ValuesType) =>
    t({ id, defaultMessage: DEFAULT_MESSAGE }, values)
}
export type IntlFunction = (
  key: keyof typeof messages,
  params?: any
) => React.ReactNode

export type IntlDateFunction = (
  value: string | number | Date,
  opts?: FormatDateOptions
) => string

export function formatIsoDate(
  formatter: IntlDateFunction,
  isoDate: string
): string {
  return formatter(isoDate)
}

export function composePageTitle(section: string): string {
  return `${section} | Clayton`
}

export function convertStringIntoHtmlList(
  source: string,
  separator: string
): JSX.Element {
  const listItems = source
    .split(separator)
    .map((item, index) => <li key={`item-${index}`}>{item}</li>)
  return <ul>{listItems}</ul>
}

export default messages
